import React, { useEffect, useState } from 'react';
import { Message, Button, Icon } from 'semantic-ui-react';
import Navbar from './Navbar';
import Footer from './Footer';

const LogoutPage = () => {
    const [countdown, setCountdown] = useState(5);
    const [isRedirecting, setIsRedirecting] = useState(true);

    useEffect(() => {
        if (!isRedirecting) return;

        const timer = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(timer);
                    setIsRedirecting(false);
                    // Use replace to ensure logout page is removed from history
                    window.location.replace('/');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isRedirecting]);

    const handleManualRedirect = () => {
        setIsRedirecting(false);
        // Use replace to ensure logout page is removed from history
        window.location.replace('/');
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <div className="login-container" style={{ flex: '1' }}>
                <div className="login-panel">
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                    <img src="/logo512.png" alt="tenantBridge" style={{ height: '56px', width: '56px' }} />
                </div>

                {/* Success Message */}
                <Message positive style={{ maxWidth: '100%', textAlign: 'center' }}>
                    <Message.Header style={{ fontSize: '1.25em', marginBottom: '0.5rem' }}>
                        Successfully Logged Out
                    </Message.Header>
                    <p style={{ marginTop: '12px', marginBottom: 0 }}>
                        Thank you for using tenantBridge. We hope to see you again soon!
                    </p>
                </Message>

                {/* Countdown Display */}
                <Message info style={{ maxWidth: '100%', textAlign: 'center', marginBottom: '1.5rem' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.75rem',
                        fontSize: '0.95rem',
                        flexWrap: 'wrap'
                    }}>
                        <Icon name="clock" />
                        <span>Redirecting to login in</span>
                        <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#062D4D',
                            color: 'white',
                            fontWeight: '700',
                            fontSize: '1.1rem',
                            width: '36px',
                            height: '36px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(53, 183, 244, 0.3)'
                        }}>
                            {countdown}
                        </span>
                        <span>seconds</span>
                    </div>
                </Message>

                {/* Action Button */}
                <div className="login-actions" style={{ marginTop: '1.5rem', gap: '1rem', flexWrap: 'wrap' }}>
                    <Button 
                        primary 
                        icon 
                        labelPosition='right'
                        onClick={handleManualRedirect}
                        size='large'
                        style={{ minWidth: '160px' }}
                    >
                        Go to Login Now
                        <Icon name='arrow right' />
                    </Button>
                </div>

                {/* Security Note */}
                <div style={{
                    marginTop: '1.5rem',
                    textAlign: 'center'
                }}>
                    <p style={{
                        fontSize: '0.875rem',
                        color: 'rgba(0,0,0,0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        margin: 0
                    }}>
                        <Icon name="lock" size="small" />
                        Your session has been securely terminated
                    </p>
                </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default LogoutPage;